import {
  BookOpenIcon,
  MusicalNoteIcon,
  CakeIcon,
  TruckIcon,
  HeartIcon,
  PaintBrushIcon,
  SparklesIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';

const lifeItems = [
  { icon: CakeIcon, label: 'Recipes & Meal Ideas' },
  { icon: TruckIcon, label: 'Food Delivery' },
  { icon: PaintBrushIcon, label: 'Art Museums' },
  { icon: BookOpenIcon, label: 'Books & Reading' },
  { icon: MusicalNoteIcon, label: 'Hobbies & Interests' },
  { icon: HeartIcon, label: 'Pet Care' },
  { icon: UserGroupIcon, label: 'Your ThriveCircle' },
  { icon: SparklesIcon, label: 'My Garden' },
];

const LifeAtHomeSection = () => {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-br from-accent/10 via-background to-secondary/15">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-lg text-primary font-bold mb-4 uppercase tracking-wider">
              More than safety
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
              Thriving Means Living, Not Just Being Safe
            </h2>
            <p className="text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              Other platforms track your health. SeniorThrive supports your whole life at home , 
              the meals you cook, the hobbies you love, the community you belong to, and the
              pets that keep you company.
            </p>
          </div>

          {/* Fun life items, lightweight grid */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-12">
            {lifeItems.map((item, i) => (
              <div
                key={i}
                className="flex flex-col items-center gap-3 p-5 rounded-md bg-card shadow-raised hover:shadow-floating hover:-translate-y-0.5 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl flex items-center justify-center">
                  <item.icon className="w-6 h-6 text-primary" />
                </div>
                <span className="text-foreground font-bold text-center leading-snug">
                  {item.label}
                </span>
              </div>
            ))}
          </div>

          {/* The differentiator statement */}
          <div className="bg-gradient-to-br from-primary/5 to-accent/10 rounded-lg p-8 md:p-10 shadow-floating text-center">
            <p className="text-xl md:text-2xl text-foreground leading-relaxed">
              Safety, wellness, and the everyday joys of life, all in one place.
              That is what makes SeniorThrive different.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LifeAtHomeSection;
